import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { GATrackingEvent, GATrackingEventPayload } from '~shared/modules/ga-tracking/models';
import get from 'lodash.get';
import {
  GATrackingEventType,
  GaTrackingEventCategory,
  GaTrackingEventName,
  GaTrackingStringConstantEnum
} from '~shared/modules/ga-tracking/constants';
import { Product } from '~app/modules/account/modules/buy-again/models';
import { getBlackWeekPaylodProperties } from '~shared/modules/ga-tracking/utils/ga-tracking-black-week.util';
import { environment } from '~env/environment';
import { BUY_AGAIN } from '~shared/constants';

export class GATrackingProductClickBuyAgainEvent implements GATrackingEvent {
  contentNameURL = `${environment.appBaseUrl()}${BUY_AGAIN}`;

  constructor(
    private product: Product,
    private priceType: PriceTypes,
    private isBlackDealsEnabled: boolean,
    private index?: number,
  ) {

  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ProductClick;
  }

  getPayload(): GATrackingEventPayload {

    const productTracking = {
      'content-name': this.contentNameURL,
      ecommerce: {
        click: {
          actionField: {
            list: 'Buy Again',
            action: 'click'
          },
          products: [
            {
              name: get(this.product, 'name'),
              id: get(this.product, 'id'),
              price:
                this.priceType === PriceTypes.b2b
                  ? get(this.product, 'bestOffer.price.vatIncluded.amount', 0)
                  : get(this.product, 'bestOffer.price.vatExcluded.amount', 0),
              brand: get(this.product, 'brand.name', ''),
              category: get(this.product, 'breadcrumbsFull.name', ''),
              position: this.index + 1,
              dimension12: get(this.product, 'hasPromotion', false),
              dimension14: this.product.bestOffer.volumePrice?.length > 0
                ? GaTrackingStringConstantEnum.Yes
                : GaTrackingStringConstantEnum.No,
              dimension32: get(
                this.product,
                'EECLabel',
                GaTrackingStringConstantEnum.NoEECLabel
              ),
              ...getBlackWeekPaylodProperties(this.isBlackDealsEnabled, this.product),
            },
          ],
        },
      },
    };

    return {
      category: GaTrackingEventCategory.Product,
      event: GaTrackingEventName.ProductClick,
      gtmCustom: productTracking,
    };
  }
}
